import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import SEOHead from '../../../components/feature/SEOHead';

export default function ContatoObrigadoPage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const featuredTestimonial = {
    nome: 'Carlos Eduardo Mendes',
    cargo: 'CEO',
    empresa: 'Mendes Transportes Ltda',
    foto: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20male%20CEO%20transportation%20company%20confident%20warm%20smile%20portrait%20clean%20studio%20background%20corporate%20headshot%20natural%20lighting%20distinguished%20executive&width=400&height=400&seq=ibxdep-001&orientation=squarish',
    depoimento: 'Antes de conhecer a IBX Brasil, renovava meus seguros sem questionar nada. Depois da análise deles, percebi que estava pagando por coberturas que não precisava. A equipe fez um trabalho minucioso e negociou condições que eu jamais conseguiria sozinho.',
    valorEconomizado: 'R$ 87.000/ano',
  };

  return (
    <>
      <SEOHead
        title="Mensagem Enviada com Sucesso | IBX Brasil"
        description="Obrigado por entrar em contato com a IBX Brasil. Nossa equipe retornará em breve."
        canonical="https://ibxbrasil.com.br/contato/obrigado"
        noIndex={true}
      />
      <div className="min-h-screen bg-gradient-to-b from-white to-petrol-50">
        <Navbar />

        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            
            {/* Success Icon */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-24 h-24 bg-strategic-green-100 rounded-full mb-6 animate-bounce">
                <div className="w-20 h-20 bg-strategic-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-5xl text-white"></i>
                </div>
              </div>
              
              <h1 className="text-4xl sm:text-5xl font-bold text-petrol-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Mensagem Recebida com <span className="text-strategic-green-600">Sucesso!</span>
              </h1>
              
              <p className="text-lg text-petrol-700 mb-2">
                Obrigado por entrar em contato com a IBX Brasil.
              </p>
              <p className="text-base text-petrol-600 max-w-2xl mx-auto">
                Nossa equipe de especialistas analisará sua solicitação e entrará em contato <strong>em até 24 horas úteis</strong> para agendar uma análise gratuita e personalizada.
              </p>
            </div>

            {/* Countdown */}
            <div className="bg-white rounded-xl shadow-md border border-petrol-100 p-6 mb-10 text-center">
              <p className="text-sm text-petrol-600 mb-2">
                Você será redirecionado para a página inicial em:
              </p>
              <div className="text-5xl font-bold text-action-orange-500 mb-2">
                {countdown}
              </div>
              <p className="text-xs text-petrol-500">segundos</p>
            </div>

            {/* Next Actions */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-petrol-900 mb-6 text-center">
                Enquanto Aguarda, Você Pode:
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                
                {/* WhatsApp */}
                <a
                  href="https://wa.me/5577988080505?text=Ol%C3%A1%21%20Acabei%20de%20enviar%20uma%20mensagem%20pelo%20formul%C3%A1rio%20e%20gostaria%20de%20falar%20com%20a%20equipe."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white rounded-xl shadow-md border border-petrol-100 p-6 hover:shadow-xl hover:scale-105 transition-all duration-300 text-center group cursor-pointer"
                >
                  <div className="w-16 h-16 bg-strategic-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-strategic-green-500 transition-colors">
                    <i className="ri-whatsapp-line text-3xl text-strategic-green-600 group-hover:text-white transition-colors"></i>
                  </div>
                  <h3 className="text-lg font-bold text-petrol-900 mb-2">
                    Falar no WhatsApp
                  </h3>
                  <p className="text-sm text-petrol-600">
                    Atendimento imediato para dúvidas urgentes
                  </p>
                </a>

                {/* Services */}
                <Link
                  to="/servicos"
                  className="bg-white rounded-xl shadow-md border border-petrol-100 p-6 hover:shadow-xl hover:scale-105 transition-all duration-300 text-center group cursor-pointer"
                >
                  <div className="w-16 h-16 bg-action-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-action-orange-500 transition-colors">
                    <i className="ri-service-line text-3xl text-action-orange-600 group-hover:text-white transition-colors"></i>
                  </div>
                  <h3 className="text-lg font-bold text-petrol-900 mb-2">
                    Conhecer Nossos Serviços
                  </h3>
                  <p className="text-sm text-petrol-600">
                    Veja todas as soluções que oferecemos
                  </p>
                </Link>

                {/* Blog */}
                <Link
                  to="/blog"
                  className="bg-white rounded-xl shadow-md border border-petrol-100 p-6 hover:shadow-xl hover:scale-105 transition-all duration-300 text-center group cursor-pointer"
                >
                  <div className="w-16 h-16 bg-petrol-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-petrol-800 transition-colors">
                    <i className="ri-article-line text-3xl text-petrol-600 group-hover:text-white transition-colors"></i>
                  </div>
                  <h3 className="text-lg font-bold text-petrol-900 mb-2">
                    Ler Nosso Blog
                  </h3>
                  <p className="text-sm text-petrol-600">
                    Conteúdos sobre gestão de seguros
                  </p>
                </Link>

              </div>
            </div>

            {/* Testimonial Section */}
            <div className="bg-gradient-to-br from-petrol-800 to-petrol-900 rounded-2xl shadow-xl p-8 sm:p-10 text-white mb-10">
              <div className="text-center mb-6">
                <div className="inline-flex items-center gap-2 bg-white/10 text-white text-xs font-bold px-4 py-2 rounded-full mb-4 uppercase tracking-widest">
                  <i className="ri-chat-quote-line"></i>
                  Enquanto Aguarda
                </div>
                <h2 className="text-2xl sm:text-3xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Veja o Que Nossos Clientes Dizem
                </h2>
                <p className="text-petrol-200 text-sm">
                  Resultados reais de quem confiou na IBX Brasil
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-white/20">
                    <img 
                      src={featuredTestimonial.foto} 
                      alt={featuredTestimonial.nome} 
                      className="w-full h-full object-cover object-top" 
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1">
                    <p className="font-bold text-white text-base">{featuredTestimonial.nome}</p>
                    <p className="text-petrol-200 text-sm">{featuredTestimonial.cargo}</p>
                    <p className="text-petrol-300 text-sm">{featuredTestimonial.empresa}</p>
                    <div className="flex gap-1 mt-2">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-sm text-action-orange-400"></i>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <p className="text-white/90 text-base leading-relaxed mb-4 italic">
                  "{featuredTestimonial.depoimento}"
                </p>

                <div className="bg-strategic-green-500/20 rounded-lg p-4 border border-strategic-green-400/30">
                  <p className="text-xs text-strategic-green-200 font-semibold uppercase tracking-wide mb-1">
                    Resultado Obtido
                  </p>
                  <p className="text-strategic-green-300 font-bold text-xl">
                    {featuredTestimonial.valorEconomizado}
                  </p>
                </div>
              </div>

              <div className="text-center mt-6">
                <Link
                  to="/depoimentos"
                  className="inline-flex items-center gap-2 text-white hover:text-action-orange-300 font-semibold text-sm transition-colors cursor-pointer"
                >
                  Ver Todos os Depoimentos
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            {/* Additional Info */}
            <div className="bg-action-orange-50 rounded-xl border border-action-orange-100 p-6 text-center">
              <div className="w-12 h-12 bg-action-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-information-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-petrol-900 mb-2">
                O Que Acontece Agora?
              </h3>
              <div className="text-left max-w-xl mx-auto space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-action-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-xs font-bold">1</span>
                  </div>
                  <p className="text-sm text-petrol-700">
                    <strong>Análise da Solicitação:</strong> Nossa equipe revisará suas informações e necessidades específicas.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-action-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-xs font-bold">2</span>
                  </div>
                  <p className="text-sm text-petrol-700">
                    <strong>Contato Inicial:</strong> Entraremos em contato por telefone ou WhatsApp em até 24 horas úteis.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-action-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-xs font-bold">3</span>
                  </div>
                  <p className="text-sm text-petrol-700">
                    <strong>Análise Gratuita:</strong> Agendaremos uma reunião para entender melhor suas necessidades e apresentar soluções personalizadas.
                  </p>
                </div>
              </div>
            </div>

            {/* Back Button */}
            <div className="text-center mt-10">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-petrol-700 hover:text-petrol-900 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar para a Página Inicial
              </Link>
            </div>

          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}